/**
 * Shared contract interfaces and enums for the Hyphen REST API.
 */
/**
 * Describes how one route is backed on the daemon side.
 */
export var RouteClass;
(function (RouteClass) {
    RouteClass["INDEXED"] = "indexed";
    RouteClass["INDEXED_OVERLAY"] = "indexedOverlay";
    RouteClass["LIVE"] = "live";
    RouteClass["RAW"] = "raw";
    RouteClass["CROSS_DOMAIN"] = "crossDomain";
})(RouteClass || (RouteClass = {}));
/**
 * Describes which readiness model applies to one route.
 */
export var ReadinessModel;
(function (ReadinessModel) {
    ReadinessModel["INDEXED"] = "indexed";
    ReadinessModel["LIVE"] = "live";
    ReadinessModel["NONE"] = "none";
})(ReadinessModel || (ReadinessModel = {}));
/**
 * Classifies one availability failure into a client-meaningful state.
 */
export var AvailabilityKind;
(function (AvailabilityKind) {
    AvailabilityKind["CAPABILITY_DISABLED"] = "capabilityDisabled";
    AvailabilityKind["INDEX_NOT_READY"] = "indexNotReady";
    AvailabilityKind["LIVE_NOT_READY"] = "liveNotReady";
})(AvailabilityKind || (AvailabilityKind = {}));
//# sourceMappingURL=common.js.map